import { createDocModalExecutor } from '@organisms/actions/createDocModalExecutor';
import { IDeleteDocumentExecutorProps } from './IDeleteDocumentExecutorProps';
import { DeleteDocumentExecutorModal } from './DeleteDocumentExecutorModal';

export const DeleteDocumentExecutor = createDocModalExecutor<IDeleteDocumentExecutorProps>({
    modal: DeleteDocumentExecutorModal,
    defaultModalSize: 'l',
    emptyElement: <div />,
    mapProps: ({ objId, action, okButtonText, cancelButtonText, modalSize, completeHandler }) => ({
        docId: objId ?? '',
        actionKey: action.key ?? '',
        title: action.options?.title ?? '',
        message: action.options?.message ?? '',
        okButtonText,
        cancelButtonText,
        modalSize,
        completeHandler,
    }),
});
